export default __webpack_public_path__ + "static/media/repayment-channel-icon4.6a94d740.png";